// extracted by mini-css-extract-plugin
export default {"coordinate-tabs":"coordinate-tabs_coordinate-tabs__iwXgD"};